

















































































































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel,DraggerImg, PaginationPanelDay,PaginationPanelThan,PaginationPanelOrder } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { fmoney } from '@/common/util/money';
import { enums } from '@/common/enums';
import { WorkingTable, Area } from '@/http';
import ApprovalSummary from "./components/ApprovalSummary.vue";
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
        PaginationPanelDay,
        PaginationPanelThan,
        PaginationPanelOrder,
        ApprovalSummary
    },
})
export default class DataAnalysis extends Vue {
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
      flexColumnWidthArray(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '200px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            let indexy = 0;
            for (let i = 0; i < tableData.length; i++) {
                for (let j = 0; j < tableData[i].orderList.length; j++) {
                    if (tableData[i].orderList[j] === null) {
                        continue;
                    }
                    const now_temp = tableData[i].orderList[j][str] + '';
                    const max_temp = tableData[index].orderList[indexy][str] + '';
                    // console.log('valllll->', tableData[i].orderList[j], i, j, tableData[i].orderList[j][str], index, indexy);
                    if (now_temp.length > max_temp.length) {
                        index = i;
                        indexy = j;
                    }
                }
                // if (tableData[i][str] === null) {
                //     return;
                // }
                // const now_temp = tableData[i][str] + '';
                // const max_temp = tableData[index][str] + '';
                // if (now_temp.length > max_temp.length) {
                //     index = i;
                // }
            }
            // console.log('yunhuanjies', index, indexy);
            columnContent = tableData[index].orderList[indexy][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 150) {
            // 设置最小宽度
            flexWidth = 150;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public activeName = 'first';
    public fmoney = fmoney;
    //public stateType2 = enums.stateType2;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public moreThanVisible = false;
    public async exportExcel() {
        // let data = await ProjectInquiry.Export(this.searchValue);
    }

    public searchValue: any = {
        // realDeliveryStartTime: '',
        // realDeliveryEndTime: '',
        deliveryStartTime:'',
        deliveryEndTime:'',
        // originProvince: '',
        // arrivalProvince: '',
        customerBaseId:'',
        carrierId:'',
        orderBy: '',
        creationStartTime: '',
        creationEndTime: '',
        ASC: true,
    };
    public searchValueDay:any = {
        orderStartTime:'',
        orderEndTime:'',
        deliveryStartTime:'',
        deliveryEndTime:'',
        shipOrderNo:'',
        customerBaseId:'',
        carrierId:'',
        carCode:'',
        driverName:'',
        driverPhone:'',
    }
    public searchOrderValue = {
        customerBaseId:''
    }
     public moreThanValue = {     
         customerBaseId:'',
         carrierId:'', 
         carrierOrderCode:'',
         shipOrderNo:'',
         consigneeName:'',
         creationStartTime:'',
         creationEndTime:'',
         realDeliveryStartTime:'',
         realDeliveryEndTime:'',
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    // toDetail(row) {
    //     if (this.searchValue.originProvince) {
    //         let res = this.provinceArray.filter((v) => v.value == this.searchValue.originProvince)[0];
    //         this.originProvinceStr = res.text;
    //     } else {
    //         this.originProvinceStr = row.originProvince;
    //     }
    //     if (this.searchValue.arrivalProvince) {
    //         let res = this.provinceArray.filter((v) => v.value == this.searchValue.arrivalProvince)[0];
    //         this.arrivalProvinceStr = res.text;
    //     } else {
    //         this.arrivalProvinceStr = row.arrivalProvince;
    //     }
    //     this.$router.push({
    //         path: '/WayBillManage',
    //         query: {
    //             form: 'DataAnalysis',
    //             carrierOrderIdList: JSON.stringify(row.carrierOrderIdList),
    //             arrivalProvinceStr: this.arrivalProvinceStr,
    //             originProvinceStr: this.originProvinceStr,
    //             realDeliveryStartTimestr: this.timeList ? this.timeList[0] : '',
    //             realDeliveryEndTimestr: this.timeList ? this.timeList[1] : '',
    //         },
    //     });
    // }
    // toDetail2(row) {
    //     if (this.searchValue.originProvince) {
    //         let res = this.provinceArray.filter((v) => v.value == this.searchValue.originProvince)[0];
    //         this.originProvinceStr = res.text;
    //     } else {
    //         this.originProvinceStr = row.originProvince;
    //     }
    //     if (this.searchValue.arrivalProvince) {
    //         let res = this.provinceArray.filter((v) => v.value == this.searchValue.arrivalProvince)[0];
    //         this.arrivalProvinceStr = res.text;
    //     } else {
    //         this.arrivalProvinceStr = row.arrivalProvince;
    //     }
    //     this.$router.push({
    //         path: '/errorManager',
    //         query: {
    //             form: 'DataAnalysis',
    //             qualityAccidentIdList: JSON.stringify(row.qualityAccidentIdList),
    //             arrivalProvinceStr: this.arrivalProvinceStr,
    //             originProvinceStr: this.originProvinceStr,
    //             realDeliveryStartTimestr: this.timeList ? this.timeList[0] : '',
    //             realDeliveryEndTimestr: this.timeList ? this.timeList[1] : '',
    //         },
    //     });
    // }



    toDetail2(data){
      this.searchPaginThan.skip = 0;
      this.searchPaginThan.currentPage = 1;
      this.moreThanValue.customerBaseId = data.customerBaseId;
      this.moreThanValue.carrierId = data.carrierId;
      this.moreThanValue.realDeliveryStartTime = this.searchValue.deliveryStartTime;
      this.moreThanValue.realDeliveryEndTime = this.searchValue.deliveryEndTime;
      this.timeListThanShip = this.timeList;
      this.moreThanValue.creationStartTime = this.searchValue.creationStartTime;
      this.moreThanValue.creationEndTime = this.searchValue.creationEndTime;
      this.timeListThanOrder = this.creationTimeList;
      this.loadThanData();
      this.moreThanVisible = true;
    }
    public async DataAnalysisExport() {
        await WorkingTable.SumAnalysisExport(this.searchValue);
        this.$message.success('导出成功!');
    }
    public async DayAnalysisExport() {
        await WorkingTable.DayAnalysisExport(this.searchValueDay);
        this.$message.success('导出成功!');
    }
    public async OrderAnalysisExport() {
        await WorkingTable.GetDispatchReportExport(this.searchOrderValue);
        this.$message.success('导出成功!');
    }
    
    public timeList = [];
    public timeListOrder = [];
    public timeListShip = [];
    public timeListThanOrder = [];
    public timeListThanShip = [];
    public creationTimeList = [];

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('DataAnalysis', JSON.stringify(this.colData));
    }
     public colData = JSON.parse(localStorage.getItem('DataAnalysis'))
        ? JSON.parse(localStorage.getItem('DataAnalysis'))
        : [
              { title: '客户/基地名称', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '含税金额', isShow: true, disabled: false },
              { title: '及时率', isShow: true, disabled: false },
              { title: '超48H发货', isShow: true, disabled: false },
          ];
    public datetimerange(v) {
        if (v) {
            this.searchValue.deliveryStartTime = v[0];
            this.searchValue.deliveryEndTime = v[1];
        } else {
            this.searchValue.deliveryStartTime = null;
            this.searchValue.deliveryEndTime = null;
        }
    }
    // 日报表订单时间改变
    public orderDatetimerange(v) {
       if(v){
           this.searchValueDay.orderStartTime = v[0];
           this.searchValueDay.orderEndTime = v[1];
       }
       else {
           this.searchValueDay.orderStartTime = null;
          this.searchValueDay.orderEndTime = null;
       }
    }
    // 日报表发货时间改变
    public shipDatetimerange(v){
         if(v){
            this.searchValueDay.deliveryStartTime = v[0];
            this.searchValueDay.deliveryEndTime = v[1];
         }
         else {
            this.searchValueDay.deliveryStartTime = null;
            this.searchValueDay.deliveryEndTime = null;
         }
    }
    // 超48小时订单时间改变
    public orderThanDatetimerange(v){
        if(v){
            this.moreThanValue.creationStartTime = v[0];
            this.moreThanValue.creationEndTime = v[1];
         }
         else {
            this.moreThanValue.creationStartTime = null;
            this.moreThanValue.creationEndTime = null;
         }
    }
    // 超48小时发货时间改变
    public shipThanDatetimerange(v){
         if(v){
            this.moreThanValue.realDeliveryStartTime = v[0];
            this.moreThanValue.realDeliveryEndTime = v[1];
         }
         else {
            this.moreThanValue.realDeliveryStartTime = null;
            this.moreThanValue.realDeliveryEndTime = null;
         }
    }
    public creationTimeListrange(v){
        if(v){
            this.searchValue.creationStartTime = v[0];
            this.searchValue.creationEndTime = v[1];
         }
         else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
         }
    }

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        paginationDay:HTMLFormElement;
        paginationThan:HTMLFormElement;
        paginationOrder:HTMLFormElement;
        multipleTable: HTMLFormElement;
        multipleTableDay:HTMLFormElement;
        multipleThanTable:HTMLFormElement;
        multipleOrderTable:HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public handleClose(){
        this.moreThanVisible = false;
    }
    public searchFunc() {
        sessionStorage.setItem('DataAnalysis_searchValue', JSON.stringify(this.searchValue));
        sessionStorage.setItem('D_timeList', JSON.stringify(this.timeList));
        sessionStorage.setItem('D_creationTimeList', JSON.stringify(this.creationTimeList));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public searchFuncDay(){
        sessionStorage.setItem('DataAnalysis_searchValueDay', JSON.stringify(this.searchValueDay));
        sessionStorage.setItem('D_timeList_Order', JSON.stringify(this.timeListOrder));
        sessionStorage.setItem('D_timeList_Ship', JSON.stringify(this.timeListShip));
        this.$refs.paginationDay.handleCurrentChange(1);
        this.searchPaginDay.skip = 0;
    }
    public searchFuncThan(){
        this.$refs.paginationThan.handleCurrentChange(1);
        this.searchPaginThan.skip = 0;
    }
    public searchOrderFunc() {
        sessionStorage.setItem('DataAnalysis_searchValueOrder', JSON.stringify(this.searchOrderValue));
        this.$refs.paginationOrder.handleCurrentChange(1);
        this.searchPaginOrder.skip = 0;
    }

    public resetSearchValue() {
        // this.customerBaseid = '';
        // this.carrierid = '';
        this.searchValue = {
            deliveryStartTime: '',
            deliveryEndTime: '',
            customerBaseId:'',
            carrierId:'',
            orderBy: '',
            creationStartTime:'',
            creationEndTime:'',
            ASC: true,
        };
        this.timeList = [];
        this.creationTimeList = [];
        // this.timeList = [this.currentdate, this.currentdate2];
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.loadData();
        sessionStorage.setItem('DataAnalysis_searchValue', JSON.stringify(this.searchValue));
        sessionStorage.setItem('D_timeList', JSON.stringify(this.timeList));
        sessionStorage.setItem('D_creationTimeList', JSON.stringify(this.creationTimeList));
    }
    public resetSearchValueDay(){
        this.timeListOrder = [];
        this.timeListShip = [];
        this.searchValueDay = {
            orderStartTime:'',
            orderEndTime:'',
            deliveryStartTime:'',
            deliveryEndTime:'',
            shipOrderNo:'',
            customerBaseId:'',
            carrierId:'',
            carCode:'',
            driverName:'',
            driverPhone:'',
            orderBy: '',
            ASC: true,
        }
        this.$refs.multipleTableDay.clearSort();
        this.$refs.paginationDay.resetSize();
        this.$refs.paginationDay.handleSizeChange(10);
        this.loadDataDay();
        sessionStorage.setItem('DataAnalysis_searchValueDay', JSON.stringify(this.searchValueDay));
    }
    public resetSearchValueThan(){
        this.timeListThanOrder = [];
        this.timeListThanShip  =[];
        this.moreThanValue = {      
         customerBaseId:this.moreThanValue.customerBaseId,
         carrierId:this.moreThanValue.carrierId,
         carrierOrderCode:'',
         shipOrderNo:'',
         consigneeName:'',
         creationStartTime:'',
         creationEndTime:'',
         realDeliveryStartTime:'',
         realDeliveryEndTime:'',
         }
        this.$refs.multipleThanTable.clearSort();
        this.$refs.paginationThan.resetSize();
        this.$refs.paginationThan.handleSizeChange(10);
        this.loadThanData();
    }
    public resetSearchValueOrder(){
         this.searchOrderValue = {
            customerBaseId:''
        };
        this.$refs.multipleOrderTable.clearSort();
        this.$refs.paginationOrder.resetSize();
        this.$refs.paginationOrder.handleSizeChange(10);
        this.loadOrderData();
    }
    public customerBaseIds = [];
    public carrierIds = [];
    public expandType: boolean = false;
    public loading = false;
    public loadingDay = false;
    public loadingThan = false;
    public loadingOrder = false;
    public rePagin = false;
    public rePaginDay = false;
    public rePaginThan = false;
    public rePaginOrder = false;
    public total = 20;
    public totalDay = 20;
    public totalThan = 20;
    public totalOrder = 0;
    public isActive: boolean = true;
    public isActive2: boolean = false;
    public isActive3: boolean = true;
    public tableData: any = [];
    public tableDataDay:any = [];
    public tableThanData:any = [];
    public tableOrderData:any = [];
    // public async getcustomerBaseId(){
    //     let result = await WorkingTable.GetDropDownList();
    //     result.forEach((item)=>{
    //         this.customerBaseIds.push({
    //             label:item.shipperName,
    //             value: item.shipperName,
    //         })
    //     })
    // }
    // public async getcarrierId(){
    //     let result = await WorkingTable.GetCarrierList();
    //     result.data.forEach((item)=>{
    //         this.carrierIds.push({
    //             label:item.name,
    //             value: item.name,
    //         })
    //     })

    // }
    // 发货方发生改变
    // public customerBaseid = '';
    // public customerBaseidDay = '';
    // public async customerBaseIdChange(e,val){
    //     console.log(e,val,'~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    //      let result = await WorkingTable.GetDropDownList();
    //      if(val==='sum'){
    //         this.searchValue.customerBaseId = result.filter((item)=>item.shipperName===e)[0].id;
    //      }
    //      if(val==='daySum'){
    //         this.searchValueDay.customerBaseId = result.filter((item)=>item.shipperName===e)[0].id;
    //      }  
    //      console.log(this.searchValue.customerBaseId,'this.searchValue.customerBaseId');
    //      console.log(this.searchValueDay.customerBaseId,'this.searchValueDay.customerBaseId')
    // }
    // //车队名称发生改变
    // public carrierid = '';
    // public carrieridDay  ='';
    // public async carrierIdChange(e,val){
    //     console.log(e,val,'~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    //      let result = await WorkingTable.GetCarrierList();
    //      if(val==='sum'){
    //        this.searchValue.carrierId = result.data.filter((item)=>item.name===e)[0].id;
    //      }
    //      if(val==='daySum'){
    //        this.searchValueDay.carrierId = result.data.filter((item)=>item.name===e)[0].id;
    //      }
         
    //      console.log(this.searchValue.carrierId,'this.searchValue.carrierId');
    //      console.log(this.searchValueDay.carrierId,'this.searchValueDay.carrierId');
    // }
    public restaurants = [];
    async querySearchAsyncSh(queryString, cb) {
        this.searchValue.customerBaseId = '';
        let res = await WorkingTable.GetDropDownList({
            name: this.searchValue.customerBaseName,
        });
        this.restaurants = [];
        if (res) {
            res.forEach((item) => {
                this.restaurants.push({
                    id:item.id,
                    value: item.customerBaseName,
                    name: item.customerBaseContactName,
                });
            });
            cb(this.restaurants);
        }
    }
    clearAutocomplete(){
        this.searchValue.customerBaseId = '';
    }
     async handleSelectSh(item, index) {     
        this.searchValue.customerBaseId = item.id
    }
    public restaurantsDay = [];
    async querySearchAsyncShDay(queryString, cb) {
        this.searchValueDay.customerBaseId = '';
        let res = await WorkingTable.GetDropDownList({
            name: this.searchValueDay.customerBaseName,
        });
        this.restaurantsDay = [];
        if (res) {
            res.forEach((item) => {
                this.restaurantsDay.push({
                    id:item.id,
                    value: item.customerBaseName,
                    name: item.customerBaseContactName,
                });
            });
            cb(this.restaurantsDay);
        }
    }
     async handleSelectShDay(item, index) {     
        this.searchValueDay.customerBaseId = item.id
    }
    clearSelectShDay(){
        this.searchValueDay.customerBaseId = '';
    }
    public restaurantCd = [];
    async querySearchAsyncCd(queryString, cb){
          this.searchValue.carrierId = '';
          let res = await WorkingTable.GetCarrierList({
            name: this.searchValue.carrierName,
            count: 30,
        });
        this.restaurantCd = [];
        if (res) {
            res.data.forEach((item) => {
                this.restaurantCd.push({
                    id:item.id,
                    value: item.name,
                    name: item.contactName,
                });
            });
            cb(this.restaurantCd);
        }
    }
    clearSelectCd(){
        this.searchValue.carrierId = '';
    }
    async handleSelectCd(item,index){
       this.searchValue.carrierId = item.id;
    }
     public restaurantCdDay = [];
    async querySearchAsyncCdDay(queryString, cb){
          this.searchValueDay.carrierId = '';
          let res = await WorkingTable.GetCarrierList({
            name: this.searchValueDay.carrierName,
            count: 30,
        });
        this.restaurantCdDay = [];
        if (res) {
            res.data.forEach((item) => {
                this.restaurantCdDay.push({
                    id:item.id,
                    value: item.name,
                    name: item.contactName,
                });
            });
            cb(this.restaurantCdDay);
        }
    }
    async handleSelectCdDay(item,index){
       this.searchValueDay.carrierId = item.id;
    }
    clearSelectCdDay(){
        this.searchValueDay.carrierId = '';
    }
    public dispatchTotalReport:any = {};

    public handleClick(val){
        if(this.activeName==='three'){
            this.getDispatchTotalReport();
        }
    }
    getDispatchTotalReport(){
        WorkingTable.GetDispatchTotalReport({
            customerBaseId: ''
        }).then(res=>{
            this.dispatchTotalReport = res;
            
        })
    }

    public orderRestaurants = [];
    async querySearchAsyncOrder(queryString, cb) {
        this.searchOrderValue.customerBaseId = '';
        let res = await WorkingTable.GetDropDownList({
            name: queryString,
        });
        this.orderRestaurants = [];
        if (res) {
            res.forEach((item) => {
                this.orderRestaurants.push({
                    id:item.id,
                    value: item.customerBaseName,
                    name: item.customerBaseContactName,
                });
            });
            cb(this.orderRestaurants);
        }
    }
    clearAutocompleteOrder(){
        this.searchOrderValue.customerBaseId = '';
    }
     async handleSelectOrder(item, index) {     
        this.searchOrderValue.customerBaseId = item.id;
    }
    public async loadData() {
        this.loading = true;
        try {
            let res = await WorkingTable.GetSummarize({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            // if (res.data && res.data.length > 0) {
            //     res.data.forEach((i) => {
            //         i.totalFeeAmount = fmoney(i.totalFeeAmount, 2, false);
            //     });
            // }
            this.tableData = res.data;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            let skip = this.searchPagin.skip;
            //this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
    public async loadDataDay(){
       this.loadingDay = true;
       try {
          let res = await WorkingTable.GetDayReport({
              ...this.searchValueDay,
               skip: this.searchPaginDay.skip,
               count: this.searchPaginDay.count,
          });
          this.tableDataDay = res.data;
          this.$refs.paginationDay.setNowPage(this.searchPaginDay.count);
          this.$refs.paginationDay.setPage(this.searchPaginDay.currentPage);
          let skip = this.searchPaginDay.skip;
          this.tableDataDay.map((item, index) => {
                item.index = skip++ + 1;
          });
          this.totalDay = res.total;
          this.loadingDay = false;
       }
       catch {
          this.loadingDay = false;
       }
    }
    public async loadThanData(){
       this.loadingThan = true;
         try {
          let res = await WorkingTable.GetDataThan({
              ...this.moreThanValue,
               skip: this.searchPaginThan.skip,
               count: this.searchPaginThan.count,
          });
          this.tableThanData = res.data;
          this.$refs.paginationThan.setNowPage(this.searchPaginThan.count);
          this.$refs.paginationThan.setPage(this.searchPaginThan.currentPage);
          let skip = this.searchPaginThan.skip;
          this.tableThanData.map((item, index) => {
                item.index = skip++ + 1;
          });
          this.totalThan = res.total;
          this.loadingThan = false;
       }
       catch {
          this.loadingThan = false;
       }
    }

    public async loadOrderData(){
       this.loadingOrder = true;
       try {
          let res = await WorkingTable.GetDispatchReport({
               customerBaseId: this.searchOrderValue.customerBaseId,
               skip: this.searchPaginOrder.skip,
               count: this.searchPaginOrder.count,
          });
          this.tableOrderData = res.data;
          this.$refs.paginationOrder.setNowPage(this.searchPaginOrder.count);
          this.$refs.paginationOrder.setPage(this.searchPaginOrder.currentPage);
          let skip = this.searchPaginOrder.skip;
          this.tableOrderData.map((item, index) => {
                item.index = skip++ + 1;
          });
          this.totalOrder = res.total;
          this.loadingOrder = false;
       }
       catch {
          this.loadingOrder = false;
       }
    }

    public created() {}

    currentdate = '';
    currentdate2 = '';

    public originProvinceStr = '';
    public arrivalProvinceStr = '';

    public provinceArray: any = [];
    async getProvince() {
        let area = await Area.area();
        this.provinceArray = area.data;
    }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        this.getProvince();
        // this.getcustomerBaseId();
        // this.getcarrierId();
        var date = new Date();
        var seperator1 = '-';
        var year = date.getFullYear();
        var month: any = date.getMonth() + 1;
        var strDate: any = date.getDate();
        if (month >= 1 && month <= 9) {
            month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = '0' + strDate;
        }
        this.currentdate = year + seperator1 + month + seperator1 + '01 ' + '00:00:00';
        this.currentdate2 = year + seperator1 + month + seperator1 + strDate + ' 00:00:00';
        // this.timeList = [this.currentdate, this.currentdate2];
        // this.searchValue.deliveryStartTime = this.currentdate;
        // this.searchValue.deliveryEndTime = this.currentdate2;

        if (sessionStorage.getItem('DataAnalysis_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('DataAnalysis_searchValue'));
            this.timeList = JSON.parse(sessionStorage.getItem('D_timeList'));
            this.creationTimeList = JSON.parse(sessionStorage.getItem('D_creationTimeList'));
            this.searchPagin = sessionStorage.getItem('DataAnalysis_page')
                ? JSON.parse(sessionStorage.getItem('DataAnalysis_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('DataAnalysis_page')
                ? JSON.parse(sessionStorage.getItem('DataAnalysis_page'))
                : this.searchPagin;

            this.loadData();
        }
        if(sessionStorage.getItem('DataAnalysis_searchValueDay')){
            this.searchValueDay = JSON.parse(sessionStorage.getItem('DataAnalysis_searchValueDay'));
            this.searchPaginDay = sessionStorage.getItem('DataAnalysis_page_Day') 
            ? JSON.parse(sessionStorage.getItem('DataAnalysis_page_Day'))
            : this.searchPaginDay;

            this.loadDataDay();
        }
        else {
            this.searchPaginDay = sessionStorage.getItem('DataAnalysis_page_Day') 
            ? JSON.parse(sessionStorage.getItem('DataAnalysis_page_Day'))
            : this.searchPaginDay;

            this.loadDataDay();
        }
        //开单派车
        if(sessionStorage.getItem('DataAnalysis_searchValueOrder')){
            this.searchOrderValue = JSON.parse(sessionStorage.getItem('DataAnalysis_searchValueOrder'));
            this.searchPaginOrder = sessionStorage.getItem('DataAnalysis_page_Order') 
            ? JSON.parse(sessionStorage.getItem('DataAnalysis_page_Order'))
            : this.searchPaginOrder;

            this.loadOrderData();
        }
        else {
            this.searchPaginOrder = sessionStorage.getItem('DataAnalysis_page_Order') 
            ? JSON.parse(sessionStorage.getItem('DataAnalysis_page_Order'))
            : this.searchPaginOrder;
            this.loadOrderData();
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public searchPaginDay:Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    }
    public searchPaginThan:Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    }
    public searchPaginOrder:Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('DataAnalysis_page', JSON.stringify(pagin));
        this.loadData();
    }
    public onPaginationChangeDay(pagin:Pagination){
        this.searchPaginDay = pagin;
        sessionStorage.setItem('DataAnalysis_page_Day',JSON.stringify(pagin));
        this.loadDataDay();
    }
    public onPaginationChangeThan(pagin:Pagination){
        this.searchPaginThan = pagin;
        this.loadThanData();
    }
    public onPaginationChangeOrder(pagin:Pagination){
        this.searchPaginOrder = pagin;
        sessionStorage.setItem('DataAnalysis_page_Order',JSON.stringify(pagin));
        this.loadOrderData();
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.ASC = true;
        } else {
            this.searchValue.ASC = false;
        }
        switch (col.prop) {
            case 'contactName':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'contactPhone':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
            case 'score':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
            case 'enabled':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 5;
                }
                break;
        }
        this.loadData();
    }
    getStrWithSimonFromNum(num) {
        let numstr = num.toString();
        let arr = numstr.split('.');
        if (arr.length > 1) {
            return arr[0].toString().includes('-')
                ? '-' +
                      arr[0]
                          .toString()
                          .split('')
                          .reverse()
                          .join('')
                          .match(/\d{1,3}/g)
                          .join(',')
                          .split('')
                          .reverse()
                          .join('') +
                      '.' +
                      arr[1]
                : arr[0]
                      .toString()
                      .split('')
                      .reverse()
                      .join('')
                      .match(/\d{1,3}/g)
                      .join(',')
                      .split('')
                      .reverse()
                      .join('') +
                      '.' +
                      arr[1];
        } else {
            return arr[0].toString().includes('-')
                ? '-' +
                      arr[0]
                          .toString()
                          .split('')
                          .reverse()
                          .join('')
                          .match(/\d{1,3}/g)
                          .join(',')
                          .split('')
                          .reverse()
                          .join('')
                : arr[0]
                      .toString()
                      .split('')
                      .reverse()
                      .join('')
                      .match(/\d{1,3}/g)
                      .join(',')
                      .split('')
                      .reverse()
                      .join('');
        }
    }
   async GetExport(){
        await WorkingTable.GetExport(this.moreThanValue);
        this.$message.success('导出成功!');
    }
}
